import { render, staticRenderFns } from "./GuideMs.vue?vue&type=template&id=c2243fa2&scoped=true&"
import script from "./GuideMs.vue?vue&type=script&lang=js&"
export * from "./GuideMs.vue?vue&type=script&lang=js&"
import style0 from "./GuideMs.vue?vue&type=style&index=0&id=c2243fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2243fa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
